import { useIsSendByRelayer } from '~/components/Exchange/hooks'
import SendBySelfTradeFee from './SendBySelfTradeFee'
import SendByRelayerTradeFee from './SendByRelayerTradeFee'
import CrossTradeFee from './CrossTradeFee'
interface Props {
  fee: bigint
  feeFactor: number
  isCrossSwap: boolean
  loading: boolean
}

const TradeFee: React.FC<Props> = ({
  fee,
  feeFactor,
  isCrossSwap,
  loading,
}) => {
  const isSendByRelayer = useIsSendByRelayer()
  return isSendByRelayer ? (
    <SendByRelayerTradeFee settlementFeeAmount={fee} loading={loading} />
  ) : isCrossSwap ? (
    <CrossTradeFee fee={fee} loading={loading} />
  ) : (
    <SendBySelfTradeFee
      tradeFee={fee}
      feeFactor={feeFactor}
      loading={loading}
    />
  )
}

export default TradeFee
